import { render } from "./Formations.vue?vue&type=template&id=915b9b3c&scoped=true&ts=true"
import script from "./Formations.vue?vue&type=script&lang=ts"
export * from "./Formations.vue?vue&type=script&lang=ts"

import "./Formations.vue?vue&type=style&index=0&id=915b9b3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-915b9b3c"]])

export default __exports__